import { emojiMap, emojiUrl } from './emojiMap'

export function filterCallingMessage(currentMessageList) {
    currentMessageList.forEach((item) => {
        if (item.callType) { // 对于自己伪造的消息不需要解析
            return
        }
        if (item.type === window.$TIM_TYPES.MSG_MERGER && item.payload.downloadKey !== '') {
            const promise = window.$TIM.downloadMergerMessage(item)
            promise.then(function (imResponse) {
                // 下载成功后，SDK会更新 message.payload.messageList 等信息
                item = imResponse
            }).catch(function (imError) {
                // 下载失败
                console.warn('downloadMergerMessage error:', imError)
            })
        }
        if (item.type === window.$TIM_TYPES.MSG_CUSTOM) {
            let payloadData = {}
            try {
                payloadData = JSON.parse(item.payload.data)
            } catch (e) {
                payloadData = {}
            }
            if (payloadData.businessID === 1) {
                if (item.conversationType === window.$TIM_TYPES.CONV_GROUP) {
                    if (payloadData.actionType === 5) {
                        item.nick = payloadData.inviteeList ? payloadData.inviteeList.join(',') : item.from
                    }
                    const _text = window.trtcCalling.extractCallingInfoFromMessage(item)
                    const group_text = `${_text}`
                    item.type = window.$TIM_TYPES.MSG_GRP_TIP
                    const customData = {
                        operationType: 256,
                        text: group_text,
                        userIDList: []
                    }
                    item.payload = customData// JSON.stringify(customData)
                }
                if (item.conversationType === window.$TIM_TYPES.CONV_C2C) {
                    const c2c_text = window.trtcCalling.extractCallingInfoFromMessage(item)
                    const customData = {
                        text: c2c_text
                    }
                    item.payload = customData// JSON.stringify(customData)
                }
            }
        }
    })
}

// 返回年月日
export function getDate(date, splitor = '-') {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}${splitor}${addZeroPrefix(month)}${splitor}${addZeroPrefix(day)}`
}

export function isToday(date) {
    return date.toDateString() === new Date().toDateString()
}

export function getFullDate(date) {
    return `${getDate(date)} ${getTime(date)}`
}

// 返回时分秒/时分
export function getTime(date, withSecond = false) {
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return withSecond ? `${addZeroPrefix(hour)}:${addZeroPrefix(minute)}:${addZeroPrefix(second)}` : `${hour}:${addZeroPrefix(minute)}`
}

// 个位数，加0前缀
function addZeroPrefix(number) {
    return number < 10 ? `0${number}` : number
}

/** 传入messageBody（群系统消息SystemMessage，群提示消息GroupTip除外）
 * payload = {
 *  msgType: 'TIMTextElem',
 *  msgContent: {
 *    text: 'AAA[龇牙]AAA[龇牙]AAA[龇牙AAA]'
 *  }
 *}
 **/
export function decodeText(payload) {
    const renderDom = []
    // 文本消息
    let temp = payload.text
    let left = -1
    let right = -1
    while (temp !== '') {
        left = temp.indexOf('[')
        right = temp.indexOf(']')
        switch (left) {
            case 0:
                if (right === -1) {
                    renderDom.push({
                        name: 'text',
                        text: temp
                    })
                    temp = ''
                } else {
                    const _emoji = temp.slice(0, right + 1)
                    if (emojiMap[_emoji]) {
                        renderDom.push({
                            name: 'img',
                            src: emojiUrl + emojiMap[_emoji]
                        })
                        temp = temp.substring(right + 1)
                    } else {
                        renderDom.push({
                            name: 'text',
                            text: '['
                        })
                        temp = temp.slice(1)
                    }
                }
                break
            case -1:
                renderDom.push({
                    name: 'text',
                    text: temp
                })
                temp = ''
                break
            default:
                renderDom.push({
                    name: 'text',
                    text: temp.slice(0, left)
                })
                temp = temp.substring(left)
                break
        }
    }
    return renderDom
}

/**
 * 格式化video通话时间
 * @export
 * @param {number} int
 * @returns
 */
function formatInt(int) {
    return int < 10 ? `0${int}` : int
}
export function formatDuration(duration) {
    if (duration < 60) {
        return `00:00:${formatInt(duration)}`
    }
    if (duration < 60 * 60) {
        const min = parseInt(duration / 60)
        const sec = duration - min * 60
        return `00:${formatInt(min)}:${formatInt(sec)}`
    }
    const hour = parseInt(duration / (60 * 60))
    const remainder = duration - hour * (60 * 60)
    const min = parseInt(remainder / 60)
    const sec = remainder - min * 60
    return `${formatInt(hour)}:${formatInt(min)}:${formatInt(sec)}`
}

export const ACTION = {
    VIDEO_AUDIO_CALL: 1,
    // VIDEO_CALL_ACTION_ERROR: -2,
    // VIDEO_CALL_ACTION_UNKNOWN: -1,
    VIDEO_CALL_ACTION_DIALING: 0, // 正在呼叫
    VIDEO_CALL_ACTION_SPONSOR_CANCEL: 2, // 发起人取消
    VIDEO_CALL_ACTION_REJECT: 4, // 拒接电话
    VIDEO_CALL_ACTION_SPONSOR_TIMEOUT: 5, // 无人接听
    VIDEO_CALL_ACTION_ACCEPTED: 3, // 连接进入通话
    VIDEO_CALL_ACTION_HANGUP: 5 // 挂断
    // VIDEO_CALL_ACTION_LINE_BUSY: 5 // 电话占线
}
/**
 * 1: 仅仅是一个带链接的文本消息
 * 2: iOS支持的视频通话版本，后续已经不兼容
 * 3: Android/iOS/Web互通的视频通话版本
 */
export const VERSION = 3
